const AppConstants = {
    USER_TYPES: ['Admin', 'LeagueOps', 'Participant', 'Payment'],
    EVENT_ROLES: ['EVENT_ADMIN', 'EVENT_STAFF', 'AGENT'],
    EVENT_ROLES_VALUES: ['Event Admin', 'Event Staff'],
    EVENT_MODULES: {
        TRANSPORTATION: 1,
        COMBINE_REGISTRATION: 2,
        INVITATION: 3,
        COMBINE_HOTEL: 4,
        DRAFT_REGISTRATION: 6,
        ALL_STAR_HOTEL: 7,
        DRAFT_TICKET: 8,
        SAT_NIGHT_TRANSPORT: 12,
        VIP: 13,
        SOCIAL_RESPONSIBILITY: 14,
        ALL_STAR_TICKET: 17,
        ALL_STAR_REGISTRATION: 18,
        PRIVATE_TRANSPORT: 23,
        COMBINE_TRANSPORTATION: 21,
        DRAFT_HOTEL: 22,
        OUTFIT: 5,
        CONTENT_CIRCUIT: 15,
        DRAFT_TRANSPORTATION: 20,
        CREDENTIAL: 25,
        COMBINE_FLIGHTINFO: 26,
        LUNCHROOM: 27,
        GREENROOM: 28,
        DRAFT_FLIGHT_INFO: 29
    },
    HOTEL_AGENT_ROOM_CONFIRM_TEXT: 'Do you want to reserve one (1) hotel room for your certified agent (at the agent’s expense)?',
    EVENT_CONFIG_NAME: {
        MY_STATS: 'MyStats'
    },
    DUMMY_EVENT_ID: 20,
};
export default AppConstants;
